import useMount from '@src/utils/hooks/use-mount';
import BreadcrumbNavStore from '@src/business-components/breadcrumb-nav/store';
import TopMenuStore from '@src/business-components/top-menu/store';
import OfficialStore from '@src/business-components/official-community/store';
import { observable } from 'mobx';
import ReturnBtnStore from '@src/business-components/return-btn/store';
import { useEffect } from 'react';

class PageLayoutStore {
  /**
   * 是否隐藏顶部菜单
   * @type {boolean}
   */
  @observable isHideTopMenu = false;
  topMenuStore;
  returnBtnStore = new ReturnBtnStore();
  breadcrumbNavStore = new BreadcrumbNavStore();
  officialStore = new OfficialStore({ type: 'other' });

  /**
   * 江湖快讯
   * 视听中心
   */
  @observable type;

  constructor(props = {}) {
    const { breadcrumbNavItems = [], isHideStrategy = false, ...rest } = props;
    this.topMenuStore = new TopMenuStore({ isHideStrategy });
    if (breadcrumbNavItems.length > 0) {
      this.breadcrumbNavStore.navItems = breadcrumbNavItems;
    }

    Object.assign(this, rest);
  }

  use() {
    useMount(() => {});

    useEffect(
      () => {
        this.officialStore.isHideTopMenu = this.isHideTopMenu;
      },
      [this.isHideTopMenu]
    );
  }
}

export default PageLayoutStore;
